var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-dialog',{staticClass:"video",attrs:{"title":_vm.title,"visible":_vm.visible,"width":"900px"},on:{"update:visible":function($event){_vm.visible=$event},"opened":_vm.playVideo,"close":_vm.destroyVideo}},[_c('div',{attrs:{"id":"player"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }